<div class="product">
  <div #visualisation class="visualisation">

  </div>
  <div class="sidebar">

    <div *ngIf="!(loaded$ | async)" class="loading-message">Loading ...</div>

    <div class="parameters">
      <ng-container #parametercards></ng-container>
    </div>
    <button mat-fab color='primary' class="button-top-right" (click)="order()"
            [disabled]="((saving$ | async) || !(loaded$ | async))">
      <mat-icon>add_shopping_cart</mat-icon>
    </button>
  </div>
</div>
